import _createClass from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);

  var _super = _createSuper(SentryError);

  /** Display name of this error instance. */
  function SentryError(message) {
    var _this;

    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warn';

    _classCallCheck(this, SentryError);

    _this = _super.call(this, message);
    _this.message = message;
    ;
    _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name; // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.

    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof SentryError ? this.constructor : void 0).prototype);
    _this.logLevel = logLevel;
    return _this;
  }

  return _createClass(SentryError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { SentryError };